import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { DiligenceCategoryStore } from 'stores/diligence/DiligenceCategoryStore';

type CategoriesProps = {
  style?: any;
  categories: DiligenceCategoryStore[];
  onToggleCategory: (category: DiligenceCategoryStore) => void;
};

const Categories = observer(({ style, categories, onToggleCategory }: CategoriesProps) => {
  return (
    <div style={style} role="list" data-testid="categories-list">
      {categories.map((category) => {
        return (
          <React.Fragment key={category.title}>
            <div role="listitem">
              <FormControlLabel
                label={category.title}
                data-testid="category-toggle"
                control={
                  <Checkbox
                    size="small"
                    checked={category.status !== 'incomplete'}
                    onChange={() => onToggleCategory(category)}
                  />
                }
              />
            </div>
            {category.ask && (
              <div
                role="listitem"
                data-testid="category-ask"
                style={{
                  fontSize: '14px',
                  marginLeft: 29,
                  whiteSpace: 'pre-wrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {category.ask}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
});

export { Categories };
